import TuevCertificate from './TuevCertificate';

export default TuevCertificate;
